<template>
    <div class="border border-grey-light rounded overflow-hidden my-5 p-5">

        <div
            :title="review.score === 1 ? '1 star' : `${review.score} stars`"
            class="mb-3"
        >
            <StarFilledIcon
                v-for="index in 5"
                :key="index"
                :class="{ 'text-orange-light' : index <= review.score }"
                class="h-3 w-3 text-grey-light mr-2 inline"
            />
        </div>

        <p class="leading-tight mb-3">
            {{ review.comment }}
        </p>

        <div class="text-sm text-semibold text-grey">
            {{ review.customer.first_name }}, {{ review.created_at }}
        </div>

    </div>
</template>

<script>
import StarFilledIcon from '~/static/fonts/LineIcons/star-filled.svg';

export default {

    components: {
        StarFilledIcon,
    },

    props: {
        review: {
            type: Object,
            required: true,
        },
    },

};
</script>

<style lang="scss" scoped>
</style>
